import EventDispatcher from '../common/EventDispatcher';
import $ from 'jquery';
import html2canvas from 'html2canvas';
import { Global } from '../common/global';
import gsap from 'gsap';
import { Lang } from '../common/lang';

export default class UploadScreen {
  constructor(camera, canvas) {}
  init() {
    this.isUploaded = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));

    document.querySelector('#upload').addEventListener('click', () => {
      if (this.isUploaded) return;
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      this.upload();
    });
    document.querySelector('#imageUpload').addEventListener('click', () => {
      if (this.isUploaded) return;
      // Global.soundEnabled && document.querySelector('#tapAudio').play();
      if (!this.isDragging) $('#fileInput').trigger('click');
    });
    $('#fileInput').change((event) => {
      if (this.isUploaded) return;
      const target = event.target;
      const imagePreviewElement = document.querySelector(
        `#preview-selected-image`
      );

      this.resetUploader();
      if (target.files && target.files[0]) {
        this.isDragging = true;
        // document.querySelector(`#sizeError`).style.opacity = 0
        document.querySelector(`#preview-selected-image`).style.opacity = 1;
        // Global[`scale`] =
        //   1 * ($(`#imageUpload`).width() / $('#imageUploadPage').width());

        const imageFile = target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
          imagePreviewElement.style.display = 'block';
          imagePreviewElement.src = e.target.result;
          this.dragFunc();

          document.querySelector(`#clicktoUpload`).style.opacity = 0;
          document.querySelector(`#reUpload`).style.opacity = 1;
          document.querySelector(`.circleContainer`).style.display = 'block';
        };

        reader.readAsDataURL(imageFile);
        document.querySelector('#silhouette').style.display = 'block';
      }
    });
    document.querySelector('#reUpload').addEventListener('click', () => {
      // Global.soundEnabled && document.querySelector('#tapAudio').play();
      $('#fileInput').trigger('click');
    });
    document.querySelector('#skip').addEventListener('click', () => {
      Global.soundEnabled && document.querySelector('#tapAudio').play();
      this.skip();
    });
  }
  resetUploader() {
    this.isDragging = false;
    document.querySelector(`#preview-selected-image`).style.opacity = 0;
    const imagePreviewElement = document.querySelector(
      `#preview-selected-image`
    );
    imagePreviewElement.src = '';
    imagePreviewElement.style.display = 'none';
    document.querySelector(`#clicktoUpload`).style.opacity = 1;
    document.querySelector(`#reUpload`).style.opacity = 0;
    document.querySelector(`.circleContainer`).style.display = 'none';
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'UploadScreen') return false;

    document.querySelector('#upload_screen').classList.add('active');
    gsap.delayedCall(0.0, () => {
      document.querySelector('#upload_screen').classList.add('active2');
    });
    gsap.delayedCall(0.2, this.animateScreen.bind(this));
  }
  animateScreen() {
    gsap.delayedCall(0.0, () => {
      document.querySelector('#upload_screen .logo').classList.add('active');
    });
    gsap.delayedCall(0.2, () => {
      document
        .querySelector('#upload_screen #uploadPhoto')
        .classList.add('active');
    });
    gsap.delayedCall(0.35, () => {
      document
        .querySelector('#upload_screen .uploadBox')
        .classList.add('active');
    });
    gsap.delayedCall(0.6, () => {
      document.querySelector('#upload_screen #upload').classList.add('active');
    });
    gsap.delayedCall(0.7, () => {
      document.querySelector('#upload_screen #upload').classList.add('active');
    });
    gsap.delayedCall(0.8, () => {
      document.querySelector('#upload_screen #skip').classList.add('active');
    });
  }
  showNext() {
    gsap.delayedCall(0.0, () => {
      document.querySelector('#upload_screen .logo').classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#upload_screen #uploadPhoto')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#upload_screen .uploadBox')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#upload_screen #upload')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document
        .querySelector('#upload_screen #upload')
        .classList.remove('active');
    });
    gsap.delayedCall(0.1, () => {
      document.querySelector('#upload_screen #skip').classList.remove('active');
    });
    gsap.delayedCall(0.65, () => {
      document.querySelector('#upload_screen').classList.remove('active');
      document.querySelector('#upload_screen').classList.remove('active2');
      this.events.dispatchEvent({
        type: 'GAMESCENE_EVENTS',
        message: {
          event_type: 'show_screen',
          data: {
            screenKey: 'CharacterSelection',
          },
        },
      });
    });
    /* 
     
    */
  }
  dragFunc() {
    const container = document.getElementById('canvasContainer');
    if (!container) return console.warn('canvasContainer not found');

    let isDragging = false;
    let startX, startY, initialX, initialY;
    let dragThreshold = 5;
    let moved = false;

    let scale = 1;
    let lastDistance = 0;

    const startDrag = (clientX, clientY) => {
      isDragging = true;
      startX = clientX;
      startY = clientY;
      initialX = container.offsetLeft;
      initialY = container.offsetTop;
      container.style.cursor = 'grabbing';
      moved = false;
    };

    const doDrag = (clientX, clientY) => {
      if (!isDragging) return;
      const dx = clientX - startX;
      const dy = clientY - startY;
      if (
        Math.abs(dx) < dragThreshold &&
        Math.abs(dy) < dragThreshold &&
        !moved
      )
        return;

      moved = true;
      container.style.left = initialX + dx + 'px';
      container.style.top = initialY + dy + 'px';
    };

    const endDrag = () => {
      isDragging = false;
      container.style.cursor = 'grab';
    };

    /* ✅ MOUSE DRAG */
    container.addEventListener('mousedown', (e) => {
      e.preventDefault();
      startDrag(e.clientX, e.clientY);
    });

    document.addEventListener('mousemove', (e) => doDrag(e.clientX, e.clientY));
    document.addEventListener('mouseup', endDrag);

    /* ✅ TOUCH DRAG + PINCH */
    container.addEventListener('touchstart', (e) => {
      if (e.touches.length === 1) {
        const touch = e.touches[0];
        startDrag(touch.clientX, touch.clientY);
      }

      // ✅ Pinch start
      if (e.touches.length === 2) {
        lastDistance = getDistance(e.touches[0], e.touches[1]);
      }
    });

    document.addEventListener(
      'touchmove',
      (e) => {
        // ✅ Drag
        if (e.touches.length === 1) {
          const touch = e.touches[0];
          doDrag(touch.clientX, touch.clientY);
        }

        // ✅ Pinch zoom
        if (e.touches.length === 2) {
          const newDistance = getDistance(e.touches[0], e.touches[1]);
          const zoomFactor = newDistance / lastDistance;
          scale *= zoomFactor;

          scale = Math.min(Math.max(scale, 0.5), 3); // ✅ Limit zoom

          container.style.transform = `scale(${scale})`;
          lastDistance = newDistance;
        }
      },
      { passive: false }
    );

    document.addEventListener('touchend', endDrag);

    /* ✅ CTRL + MOUSE WHEEL ZOOM (DESKTOP) */
    container.addEventListener('wheel', (e) => {
      if (!e.ctrlKey) return;
      e.preventDefault();

      scale += e.deltaY * -0.005;
      scale = Math.min(Math.max(0.5, scale), 3);

      container.style.transform = `scale(${scale})`;
    });

    /* ✅ Helper Function */
    function getDistance(touch1, touch2) {
      const dx = touch1.clientX - touch2.clientX;
      const dy = touch1.clientY - touch2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
  }
  showError(err) {
    this.bool = false;
    document.querySelector('.errorSec').innerHTML = err;
    document.querySelector('.errorSec').classList.add('active');
    this.errorTO && clearTimeout(this.errorTO);
    this.errorTO = setTimeout(() => {
      document.querySelector('.errorSec').classList.remove('active');
    }, 1000);
    // document.getElementById('error').innerHTML = err;
    // document.getElementById('error').style.display = 'block';
  }
  upload() {
    if (this.isUploaded) return;

    // document.querySelector('#languageSelection_screen').style.display = 'none';
    const target = document.getElementById('imageUpload');
    const silhouette = document.getElementById('silhouette');
    const circleContainer = document.querySelector('.circleContainer');
    const reUpload = document.querySelector('#reUpload');

    // Hide silhouette temporarily
    if (silhouette) silhouette.style.display = 'none';
    if (circleContainer) circleContainer.style.display = 'none';
    if (reUpload) reUpload.style.display = 'none';
    // Temporarily hide images with empty src
    target.querySelectorAll('img').forEach((img) => {
      if (!img.src || img.src === window.location.origin + '/') {
        img.dataset.removed = 'true';
        img.style.display = 'none';
      }
    });

    const fileInput = document.getElementById('fileInput');
    if (!fileInput.files || fileInput.files.length === 0) {
      this.showError(Lang.userImage[Global.lang]);
      return;
    }

    this.isUploaded = true;
    html2canvas(target, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      logging: false,
      backgroundColor: null,
    }).then((canvas) => {
      // ✂️ Trim 1px border to remove tiny extra lines
      const trimmedCanvas = document.createElement('canvas');
      trimmedCanvas.width = Math.max(1, Math.round(canvas.width) - 1);
      trimmedCanvas.height = Math.max(1, Math.round(canvas.height) - 1);
      const ctx = trimmedCanvas.getContext('2d');
      ctx.drawImage(
        canvas,
        0,
        0,
        canvas.width - 1,
        canvas.height - 1,
        0,
        0,
        trimmedCanvas.width,
        trimmedCanvas.height
      );

      const imgData = trimmedCanvas.toDataURL('image/png');
      this.cropedImage = imgData;

      const divScreenshotBase64 = this.cropedImage;
      if (!divScreenshotBase64) {
        console.warn('⚠️ No div screenshot found (this.cropedImage is empty)');
      }
      const reader = new FileReader();
      const imageFile = fileInput.files[0];

      reader.onload = (e) => {
        const userImageBase64 = e.target.result;

        Global.serverObj.send(Global.URL_VUPDATE, null, null, {
          saveType: 'uploadClick',
          uniqID: Global.U_ID,
        });
        // ✅ Send all data together (as before)
        Global.serverObj.send(
          `${Global.BASE_URL}webservice.php`,
          (response) => {
            if (response.code == 200) {
              Global.profileUrl = response.url;
              this.events.dispatchEvent({
                type: 'GAME_EVENTS',
                message: {
                  event_type: 'add_pin',
                  data: {},
                },
              });

              this.showNext();
            } else {
              alert('somthing went wrong.');
            }
          },
          null,
          {
            saveType: 'saveImage',
            uniqID: Global.U_ID,

            // 👇 Added base64 data
            userImageBase64: userImageBase64,
            divScreenshotBase64: divScreenshotBase64 || '',
          },
          'POST',
          null,
          false
        );
      };
      reader.readAsDataURL(imageFile);

      // Restore hidden elements
      if (silhouette) silhouette.style.display = 'block';
      if (circleContainer) circleContainer.style.display = 'block';
      if (reUpload) reUpload.style.display = 'block';
      target.querySelectorAll('img[data-removed]').forEach((img) => {
        img.style.display = '';
        img.removeAttribute('data-removed');
      });
    });
    // this.events.dispatchEvent({
    //   type: 'USER_EVENTS',
    //   message: {
    //     event_type: 'changeScreen',
    //     data: {
    //       curentScreen: 'start_screen',
    //       nextScreen: 'form_screen',a
    //     },
    //   },
    // });
  }
  skip() {
    Global.profileUrl = null;
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'add_pin',
        data: {
          imgUrl: null,
        },
      },
    });
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: 'skipClick',
      uniqID: Global.U_ID,
    });
    this.showNext();
    // this.events.dispatchEvent({
    //   type: 'USER_EVENTS',
    //   message: {
    //     event_type: 'changeScreen',
    //     data: {
    //       curentScreen: 'upload_screen',
    //       nextScreen: 'charecter_screen',
    //     },
    //   },
    // });
  }
}
